import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import tr from "./locales/tr.json";
import en from "./locales/en.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";

export const LANGUAGES = [
  { code: "tr", name: "Türkçe", flag: "🇹🇷", translation: tr },
  { code: "en", name: "English", flag: "🇬🇧", translation: en },
  { code: "de", name: "Deutsch", flag: "🇩🇪", translation: de },
  { code: "es", name: "Español", flag: "🇪🇸", translation: es },
  { code: "fr", name: "Français", flag: "🇫🇷", translation: fr }
];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: Object.fromEntries(LANGUAGES.map(({ code, translation }) => [code, { translation }])),
    fallbackLng: "tr",
    supportedLngs: LANGUAGES.map(({ code }) => code),
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false // react already protects from xss
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"]
    }
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export const formatDate = (dateVal) =>
  dateVal ? new Date(dateVal).toLocaleDateString(i18n.resolvedLanguage) : "";

export const formatDateTime = (dateVal) =>
  dateVal ? new Date(dateVal).toLocaleString(i18n.resolvedLanguage) : "";

export default i18n;
